<div class="auth-page">
  <div class="auth-card">
    <div class="auth-card-inner">
      <div class="auth-visual">
        <p class="auth-visual-kicker">Appstrax</p>
        <h1 class="auth-visual-title">Sign up</h1>
        <p class="auth-visual-subtitle">to get started</p>
        <div class="auth-visual-deco" aria-hidden="true"></div>
      </div>

      <div class="auth-form">
        <h2 class="auth-form-title">Welcome!</h2>
        <p class="auth-form-lead">Create your account</p>

        <form (ngSubmit)="register()" #form="ngForm" autocomplete="off">
          <div class="form-group">
            <label for="name" class="visually-hidden">First name</label>
            <div class="input-with-icon">
              <i class="bi bi-person"></i>
              <input
                type="text"
                class="form-control"
                id="name"
                name="name"
                [(ngModel)]="user.name"
                placeholder="First name"
                required
              />
            </div>
          </div>

          <div class="form-group">
            <label for="surname" class="visually-hidden">Last name</label>
            <div class="input-with-icon">
              <i class="bi bi-person"></i>
              <input
                type="text"
                class="form-control"
                id="surname"
                name="surname"
                [(ngModel)]="user.surname"
                placeholder="Last name"
                required
              />
            </div>
          </div>

          <div class="form-group">
            <label for="email" class="visually-hidden">Email</label>
            <div class="input-with-icon">
              <i class="bi bi-envelope"></i>
              <input
                type="email"
                class="form-control"
                id="email"
                name="email"
                [(ngModel)]="user.email"
                placeholder="Email address"
                required
              />
            </div>
          </div>

          <div class="form-group">
            <label for="password" class="visually-hidden">Password</label>
            <div class="input-with-icon">
              <i class="bi bi-lock"></i>
              <input
                type="password"
                class="form-control"
                id="password"
                name="password"
                [(ngModel)]="user.password"
                placeholder="Password"
                required
              />
            </div>
          </div>

          @if (errorMessage) {
            <div class="alert alert-danger mb-3">
              {{ errorMessage }}
            </div>
          }

          <button
            class="btn btn-primary auth-submit"
            type="submit"
            [disabled]="!isFormValid()"
            [ngClass]="{ disabled: isLoading }"
          >
            @if (isLoading) {
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            }
            <span class="ms-2" role="status">Create account</span>
          </button>
        </form>

        <p class="auth-footer-link">
          Already have an account? <a routerLink="/login">Log in</a>
        </p>
      </div>
    </div>
  </div>
</div>
